import { AppSearchBox, AppSelect } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Calendar } from 'lucide-react'

type SalesFilterSectionProps = {
  selectedPeriod: string | null
  onPeriodChange: (period: string | null) => void
  searchText: string
  onSearchTextChange: (text: string) => void
  availablePeriods: string[]
}

export function SalesFilterSection({
  selectedPeriod,
  onPeriodChange,
  searchText,
  onSearchTextChange,
  availablePeriods,
}: SalesFilterSectionProps) {
  return (
    <div className='space-y-2'>
      <p className='font-bold'>起票したオポに紐づく売上一覧</p>

      <div className='flex flex-row sm:flex-row gap-4'>
        <AppSelect
          leftIcon={<Calendar />}
          label='期を選択'
          value={selectedPeriod || undefined}
          onValueChange={onPeriodChange}
          placeholder='期を選択'
          options={availablePeriods.map((period) => ({ value: period, label: period }))}
        />
        <AppSearchBox
          label='売上情報を検索'
          value={searchText}
          onChange={onSearchTextChange}
          placeholder='取引先名、案件名、IDで絞り込み'
        />
      </div>
    </div>
  )
}
